<template>
  <div class="mit-home-page mit-page">
    <BaseMitLoading :show="loadingSpaces || loadingFavorites" :fullscreen="false"/>
        <v-snackbar top :color="status.color" min-width="0" v-model="status.display" :timeout="status.timeout">
            <b>{{ status.message }}</b>
        </v-snackbar>
      <v-container fluid>
          <v-row>
            <v-col cols="12" class="d-flex">
              <v-card class="mit-info-card" style="width:100%">
                  <v-card-title>Settings</v-card-title>
                  <v-card-subtitle class="caption">Change user settings</v-card-subtitle>
                  <v-divider></v-divider>

                  <v-card-text>

                    <v-dialog v-model="dialogFavorites" width="600">
                      <v-card>
                          <v-card-title class="text-h7 primary lighten-2">Add Favorite Spaces
                          </v-card-title>

                        <v-card-text>
                          <v-text-field label="Search" clearable style="max-width:200px;"><v-icon slot="append">mdi-magnify</v-icon></v-text-field>
                           <v-list two-line>
                              <!-- <v-list-item-group v-model="selected" active-class="pink--text" multiple> -->
                              <v-list-item-group></v-list-item-group>
                                <template>
                                  <div v-for="(s, index) in spaces" :key="s.mitId">
                                      <v-list-item>
                                        <template v-slot:default="{ active }">
                                          <v-list-item-content>
                                            <v-list-item-title v-text="s.mitId"></v-list-item-title>

                                            <v-list-item-subtitle class="text--primary" v-text="s.org"></v-list-item-subtitle>

                                            <v-list-item-subtitle v-text="s.useType"></v-list-item-subtitle>
                                          </v-list-item-content>

                                          <v-list-item-action>
                                            <!-- <v-list-item-action-text v-text="item.action"></v-list-item-action-text> -->

                                            <v-icon v-if="!favoriteSpaces[s.mitId]" @click="saveFavorite(s.mitId)" color="grey lighten-1">
                                              mdi-heart
                                            </v-icon>

                                            <v-icon v-else color="red lighten-1" @click="deleteFavorite(s.mitId)">
                                              mdi-heart
                                            </v-icon>
                                          </v-list-item-action>
                                        </template>
                                      </v-list-item>

                                      <v-divider></v-divider>
                                  </div>
                                </template>
                              </v-list-item-group>
                            </v-list>
                        </v-card-text>
                        <v-divider></v-divider>

                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn color="primary" @click="dialogFavorites = false">Close</v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                    <v-toolbar color="grey lighten-2" dense outlined elevation="1">
                      <v-spacer></v-spacer>
                      <v-toolbar-title>Favorite Spaces</v-toolbar-title>
                      <v-spacer></v-spacer>
                      <v-btn depressed color="primary" @click="dialogFavorites = true;" >Add </v-btn>
                    </v-toolbar>
                    <v-row dense>

                        <v-col v-for="(s, i) in spaces" :key="i" cols="12">
                          <v-card>
                            <div class="d-flex flex-no-wrap justify-space-between">
                              <div>
                                  <v-card-title class="text-h5" v-text="s.mitId"></v-card-title>
                                  <v-card-subtitle v-text="s.level"></v-card-subtitle>

                                  <v-card-actions>
                                    <v-btn class="ml-2 mt-5" outlined rounded small>Remove Favorite</v-btn>
                                  </v-card-actions>
                              </div>

                              <v-avatar class="ma-3" size="125" tile>
                                <!-- <v-img :src="item.src"></v-img> -->
                              </v-avatar>
                            </div>
                          </v-card>
                        </v-col>
                    </v-row>

                  </v-card-text>


              </v-card>
            </v-col>
          </v-row>
      </v-container>
  </div>
</template>

<script>
    import MitFavoritesService from '../services/MitFavoritesService.js';
    import MitSpacesApiService from '../../base/services/BaseMitReserveSpacesService.js';
    
    import BaseMitDataTable from '../../base/components/BaseMitDataTable.vue';
    import BaseMitLoading from '../../base/components/BaseMitLoading.vue';

  export default {
    name: 'MitSettingsPage',
    components: {
      BaseMitLoading,
      BaseMitDataTable
    },
    data: function() {
      return {
          status:{
            display:false,
            timeout:3000,
            message:'Saved!',
            color:'primary'
          },
          dialogFavorites:false,
          loadingSpaces:true,
          loadingFavorites:false,
          selectedSpace:null,
          spaces:[],
          favoriteSpaces:[]
      }
    },
    created(){
      this.requestGetSpaces();
      this.getFavorites();
    },
    methods: {
      // getFavorites(){
      //   this.loadingFavorites = true;
      //   return MitFavoritesService.get()
      //       .then((data) => {
      //           this.loadingFavorites = false;
      //           this.favoriteSpaces = data.favorites;
      //       })
      //       .catch((error) => {
      //           this.loadingFavorites = false;
      //           this.status.message = 'There was an error adding favorite '+ mitId;
      //           this.status.display = true;
      //           this.status.color = 'red';
      //           console.log('ERROR:', error);
      //       });
      // },
      saveFavorite(mitId){
        this.favoriteSpaces[mitId] = true;
        return MitFavoritesService.save(mitId)
            .then((data) => {
            })
            .catch((error) => {
                this.status.message = 'There was an error adding favorite '+ mitId;
                this.status.display = true;
                this.status.color = 'red';
                console.log('ERROR:', error);
                this.favoriteSpaces[mitId] = false;
            });
      },
      deleteFavorite(mitId){
        this.favoriteSpaces[mitId] = false;
        return MitFavoritesService.delete(mitId)
            .then((data) => {
            })
            .catch((error) => {
                this.status.message = 'An error removing favorite '+mitId;
                this.status.display = true;
                this.status.color = 'red';
                console.log('ERROR:', error);
                this.favoriteSpaces[mitId] = true;
            });
      },
      requestGetSpaces(){
          this.loadingSpaces = true;

          return MitSpacesApiService.getReservableSpaces()
            .then((data) => {
                this.spaces = data.spaces;
                this.loadingSpaces = false;
            })
            .catch((error) => {
                this.loadingSpaces = false;
                this.status.message = 'An error occurred trying to get spaces';
                this.status.display = true;
                this.status.color = 'red';

                console.log('ERROR:', error);
            });
      }
    }

  }
</script>

<style lang="scss" scoped>
  .mit-info-card {
    width:100%;
    height:100%;
  }
</style>
